import GoogleIcon from '../icons/GoogleIcon';
import React, { Fragment, useLayoutEffect, useState } from 'react';
import { enableOneTapGoogleLogin, loadGoogleGsiClient } from '../../utils/helpers';
import jwtDecode from 'jwt-decode';
import { DefaultButton, GoogleButtonContainer } from './GoogleButtonStyles';
import { IGoogleSignupData } from '../../screens/login/types/join';

interface IGoogleButtonProps {
  isAuthenticated?: boolean;
  onSubmit: (data: IGoogleSignupData) => void;
}

const GoogleButton: React.FC<IGoogleButtonProps> = ({ isAuthenticated = false, onSubmit }): React.ReactElement => {
  const [isGoogleScriptLoaded, setIsGoogleScriptLoaded] = useState<boolean>(false);

  useLayoutEffect(() => {
    const renderGoogleBtn = () => {
      const googleScript = loadGoogleGsiClient();
      const googleBtnElement = document.getElementById('google_btn');

      if (!googleScript || isGoogleScriptLoaded) {
        return;
      }

      enableOneTapGoogleLogin();

      googleScript.onload = () => {
        setTimeout(() => {
          if (!window.google?.accounts) {
            return;
          }

          (window.google?.accounts as any)?.id.initialize({
            client_id: process.env.REACT_APP_EXTERNAL_GOOGLE_CLIENT_ID,
            itp_support: true,
            use_fedcm_for_prompt: true,
            callback: response => {
              const responsePayload = jwtDecode(response.credential);
              const data = {
                site: 'google',
                email: responsePayload.email,
                token: response.credential,
              };

              onSubmit(data);
            },
          });

          const renderButton = () => {
            if (googleBtnElement) {
              const containerWidth = googleBtnElement.offsetWidth;

              (window.google?.accounts as any)?.id.renderButton(googleBtnElement, {
                type: 'standard',
                theme: 'filled_blue',
                shape: 'square',
                size: 'large',
                text: 'Sign in as',
                width: containerWidth || 314,
                logo_alignment: 'right',
                auto: false,
              });
            }
          };

          renderButton();
          setIsGoogleScriptLoaded(true);

          // show only when user is not authenticated and not showing login as phone number
          if (!isAuthenticated) {
            (window.google?.accounts as any)?.id.prompt();
          }

          window.addEventListener('resize', renderButton);

          return () => {
            window.removeEventListener('resize', renderButton);
          };
        }, 1500);
      };

      googleScript.onerror = () => {
        console.trace('login.debug.googleScript.onError');
      };
    };

    renderGoogleBtn();
  }, [isGoogleScriptLoaded]);

  return (
    <Fragment>
      <DefaultButton
        isDefault={true}
        buttonType="default"
        type="button"
        name="commit"
        icon={!isGoogleScriptLoaded && <GoogleIcon />}
      >
        {!isGoogleScriptLoaded && 'Continue with Google'}
        <GoogleButtonContainer isGoogleScriptLoaded={isGoogleScriptLoaded} id="google_btn" />
      </DefaultButton>
    </Fragment>
  );
};

export default GoogleButton;
